import { ReactNode } from "react";
import toast, { Toast } from "react-hot-toast";

const FullScreenToast = ({
  t,
  children,
}: {
  t: Toast;
  children: ReactNode;
}) => {
  return (
    <div className="FullScreenToast">
      <div className="FullScreenToast__message">{children}</div>
      <div className="FullScreenToast__action">
        <button onClick={() => toast.dismiss(t.id)}>Close</button>
      </div>
    </div>
  );
};

export default FullScreenToast;
